import React, { useState, useEffect, useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
// contexts
import { useAuth } from './Auth';
import { SettingsContext } from './Settings';
// services
import { getSales, getDailySales } from '../services/Report';
// helper
import { getTimeZoneDate } from '../helpers/Util';

export const ReportContext = createContext();

ReportProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function ReportProvider({ children }) {
  const [searchParams] = useSearchParams();
  const [sales, setSales] = useState();
  const [salesPerDay, setSalesPerDay] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const { authUser } = useAuth();
  const { authSettings } = useContext(SettingsContext);

  useEffect(() => {
    const fetchData = async (eventId) => {
      setIsLoading(true);

      try {
        let eventDate = null;
        let start = null;
        let end = null;

        const queryEventDate = searchParams.get('eventDate');
        const queryDateStart = searchParams.get('start');
        const queryDateEnd = searchParams.get('end');

        if (queryEventDate) {
          eventDate = getTimeZoneDate({ date: queryEventDate }).toISOString();
        }
        if (queryDateStart) {
          start = getTimeZoneDate({ date: queryDateStart }).toISOString();
        }
        if (queryDateEnd) {
          end = getTimeZoneDate({ date: queryDateEnd }).toISOString();
        }

        const idToken = await authUser.getIdToken();
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Account-Key': authSettings.server.path
        };

        const sales = await getSales({ headers, eventId, eventDate, start, end });

        const salesPerDay = await getDailySales({
          headers,
          eventId,
          eventDate
        });

        setSales(sales);
        setSalesPerDay(salesPerDay);
        setIsLoading(false);
      } catch (error) {
        setHasError(true);
        console.error(error);
      }
    };

    const eventId = searchParams.get('eventId');
    if (eventId) {
      fetchData(eventId);
    }
  }, [searchParams, authUser, authSettings, setSales]);

  return (
    <ReportContext.Provider value={{ sales, salesPerDay, isLoading, hasError }}>
      {children}
    </ReportContext.Provider>
  );
}
